import { BaseEntity } from 'yt-ng-framework';

export class KomitentKontaktOsobaView extends BaseEntity {
    constructor(){
        super();
    }
    KomitentNaziv: string = null;
    OsobaNaziv: string = null;
    Opis: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.KomitentNaziv = input.KomitentNaziv;
        this.OsobaNaziv = input.OsobaNaziv;
        this.Opis = input.Opis;
        return this;
    }

    Serialize(input: KomitentKontaktOsobaView){
        return input;
    }
}